import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductBom, ProductBomDataService } from '@vi-succ/products-domain';
import { Observable, map } from 'rxjs';
import { BomSearchResult } from '../entity';
import { environment } from '../environments/environment';
import { ProductDetailFactory } from '../factories/product-detail.factory';

@Injectable({
  providedIn: 'root',
})
export class EtProductBomDataService implements ProductBomDataService {
  constructor(private http: HttpClient) {}

  getBom(salesOrg: string, language: string, materialNumber: string, query?: string): Observable<ProductBom[]> {
    return this.http
      .get<BomSearchResult[]>(`${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}/bom`, {
        params: {
          searchToken: query ?? '',
        },
        headers: {
          'X-API-KEY': environment.backend.apiKey,
        },
      })
      .pipe(
        map((boms) =>
          boms.map((bom) => {
            const source = bom.sources
              .map((source) => ProductDetailFactory.build(source))
              .map((detail) => ({
                amount: 1,
                currency: detail.currency,
                documents: detail.documents,
                grossPrice: detail.grossPrice,
                isBaseDevice: detail.baseDevice,
                isIbau: detail.ibau,
                isSales: detail.sales,
                isSparePart: detail.sparePart,
                isWearPart: detail.wearPart,
                materialDescription: detail.materialDescription,
                materialNumber: detail.materialNumber,
                materialType: detail.materialType,
                netPrice: detail.netPrice,
                positionNumber: '',
                productImages: detail.productImages,
                unitOfMeasure: '',
                showAvailability: detail.showAvailability,
                sellableHint: detail.sellableHint,
                showPrice: detail.showPrice,
                shoppingCartState: detail.shoppingCartState,
              }));

            return {
              materialNumber: bom.materialNumber,
              description: bom.description,
              bom: source,
            };
          }),
        ),
      );
  }
}
